import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../../lib/api';

type Theme = 'light' | 'dark';

const ThemeContext = createContext<{ theme: Theme; toggleTheme: () => void }>({
  theme: 'light',
  toggleTheme: () => {},
});

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem('theme') as Theme) || 'light'
  );

  // On mount, try to load theme from DB (only works if authenticated)
  useEffect(() => {
    api.getUserUiSetting<string>('theme').then(val => {
      if (val === 'light' || val === 'dark') {
        setTheme(val);
      }
    }).catch(() => {}); // Ignore if not authenticated
  }, []);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider
      value={{ theme, toggleTheme: () => setTheme(t => t === 'light' ? 'dark' : 'light') }}
    >
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
